import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatError } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const input = "w-full bg-transparent border-b border-border py-3 focus:border-foreground outline-none transition-colors";

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-5" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <div className="font-display font-black text-4xl mb-2">Digitalis<span className="text-muted-foreground">.</span></div>
        <p className="overline text-[10px] text-muted-foreground mb-10">Admin CMS</p>
        <form onSubmit={submit} className="space-y-6">
          <div><label className="overline text-[10px] text-muted-foreground">Email</label><input className={input} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" autoComplete="username" /></div>
          <div><label className="overline text-[10px] text-muted-foreground">Password</label><input type="password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" autoComplete="current-password" /></div>
          <button type="submit" disabled={loading} className="btn-primary inline-flex items-center gap-2 rounded-full px-8 py-4 overline text-[11px] w-full justify-center transition-all disabled:opacity-50" data-testid="login-submit">{loading ? "Masuk…" : "Masuk"} <ArrowRight className="w-3.5 h-3.5" /></button>
        </form>
      </div>
    </div>
  );
}
